import { useMarketIndexes, useMarketIndexesInfo } from "@/controllers/gridManager/MarketIndexManager"
import MarketIndexChart from "./MarketIndexChart"
import MarketIndexInfo from "./MarketIndexInfo"
import './index.css'
import { convertData } from "@/stores/transformData/transformData"

function MarketIndex({ code }: { code: string }) {
    const { history } = useMarketIndexes()
    const { marketInfo } = useMarketIndexesInfo()
    const prepareData = convertData.populateMarketInfo(marketInfo[code])
    // console.log('ha_check_code', { code, prepareData });
    return (
        <div className="chart-in-day-history">
            <MarketIndexChart history={history[code]} code={code} />
            <MarketIndexInfo marketInfo={prepareData} />
        </div>
    )
}

export default MarketIndex